import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserData {
  roles: string[];
  permissions: string[];
  uid: string;
  zone: string[];
}

interface AuthState {
  email: string | null;
  userData: UserData | null;
}

const initialState: AuthState = {
  email: null,
  userData: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData(state, action: PayloadAction<{ email: string; userData: UserData }>) {
      state.email = action.payload.email;
      state.userData = action.payload.userData;
    },
    clearAuthData(state) {
      state.email = null;
      state.userData = null;
    }
  }
});

export const { setAuthData, clearAuthData } = authSlice.actions;

export default authSlice.reducer;
